import script from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"

import "./AlertMessage.vue?vue&type=style&index=0&id=c6bf988a&lang=css"

const __exports__ = script;

export default __exports__